// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--2r2aa","header":"footer-module--header--274Ba","login ":"footer-module--login --eKJAw","login":"footer-module--login--9FVyS"};